module.exports = __webpack_public_path__ + "static/img/no-oder.fce17997.png";